import { IPaginatedLandingContent } from './models/paginated-landing-content'
import { Filter } from './components/paginated-landing-content-app';

export default function matchesAnySpecialtyHelper(item: IPaginatedLandingContent, filter: Filter[]) {
    let specialtyResults = item.specialties;
    let matchesSpecialty;

    if (!specialtyResults || specialtyResults.length == 0) {
        return false
    }
    // if any filters match any specialties on this item
    for (let i = 0; i < specialtyResults.length; i++) {
        // if any specialty result matches
        if (filter.length > 0) {
            for (let n = 0; n < filter.length; n++) {
                if (specialtyResults[i].toLowerCase() === filter[n].id.toLowerCase()) {
                    matchesSpecialty = true;
                    break;
                }
            }
            if (matchesSpecialty) {
                break;
            }
        }
    }
    return matchesSpecialty;
}
